import { render } from "./RecopilarDatosPN2Detalle.vue?vue&type=template&id=4e50bde2&ts=true"
import script from "./RecopilarDatosPN2Detalle.vue?vue&type=script&lang=ts"
export * from "./RecopilarDatosPN2Detalle.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__